import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import Title from '../../Title'
import Select from 'react-select'
import SpotlightLayout from '../../layouts/SpotlightLayout'
import LineChartLayout from '../../layouts/LineChartLayout'
import NumberHorizontalLayout from '../../layouts/NumberHorizontalLayout'
import PieChartLayout from '../../layouts/PieChartLayout'
import selectFormat from "../selectFormat";
import metricDefinitions from '../../metricDefinitions'
import classnames from 'classnames'

class SurveyMetrics extends React.Component {
  state = {
    selectedOption: {value: 0, label: ''},
    selectedOptionForAverage: {value: 0, label: ''},
    therapists: [],
    selectedTherapist: 'all'
  }

  componentDidMount(){
    this.setState(( prevState, props )=>{
      return {
        selectedOption: {value: 0, label: ``},
        therapists: props.therapists,
        selectedTherapist: 'all'
      }
    })
  }

  generateOptions(){
    // check if certain surveys are enabled here. if so, display them as an option. 
    // consider passing in only data for surveys that are approved
    var options = []
    this.filteredMetrics(this.props.percentChangePerMonthMetrics, 'percent_score_per_month_metrics_').map( (metric, index) => {
      options.push({value: index, label: `${metric.title}`})
    })
    return options
  }

  generateOptionsForAverage(){
    var options = []
    this.filteredMetrics(this.props.averageScorePerMonthMetrics, 'average_score_per_month_metrics_').map( (metric, index) => {
      options.push({value: index, label: `${metric.title}`})
    })
    return options
  }

  handleChange = (selectedOption) => {
    this.setState({ ...this.state, selectedOption });
  }
  
  handleChangeForAverage = (selectedOptionForAverage) => {
    this.setState({ ...this.state, selectedOptionForAverage });
  }

  filteredMetrics(metrics, category, type='slug'){
    return metrics.filter(metric=>metric.visible == true)
                  .filter(
                    (metric) => !this.props.hiddenOutcomes.includes(`${category}${metric[type]}`)
                  )
  }

  handleTherapistChange = (newTherapist) => {
    this.setState({selectedTherapist: newTherapist})
  }

  render(){
    const { selectedOption, selectedOptionForAverage, therapists, selectedTherapist } = this.state
    const { surveys } = this.props.permissions
    const effective_parts_metric = {
      title: 'Most effective part of treatment center',
      format: 'pie_chart',
      endpoint: 'most_effective_part_of_treatment_center',
      visible: true,
    }
    const basic_metrics = metricDefinitions(this.props.organization_name, this.props.permissions)["surveys"].basic_metrics
    return(
      <div>
        <div className="col-12">
          {
            basic_metrics
              .filter((metric) => metric.visible == true)
              .filter(
                (metric) => !this.props.hiddenOutcomes.includes(`basic_metrics_${metric.slug}`)
              )
              .map((metric, index) => {
                return selectFormat(
                  metric,
                  index,
                  this.props
                );
              })
          }
        </div>
        {
          (surveys.sl_mss || surveys.bayshore_exit_survey) && 
          <div className="ml-4">
            <div className="col-12 mt-4 bg-white p-0 shadow">
              <div className="bg-info p-3">
                <div className="d-flex justify-content-between">
                  <div className="col-12 text-align-left title">Survey Average Score</div>
                  <ClinicianSelect therapists={therapists} handleChange={this.handleTherapistChange}/>
                </div>
                <div className="col-12 text-align-left description">These metrics are calculated by taking the average of all survey scores within the filters.</div>
              </div>
              <div className="col-12 d-flex flex-wrap p-4 ml-2">
                { 
                  this.filteredMetrics(this.props.averageMetrics, 'average_metrics_').map((metric, index) => {
                    return(
                      <SpotlightLayout
                        {...this.props}
                        visible
                        index={index}
                        key={index}
                        metric={metric}
                        therapist={selectedTherapist}
                        hasLeftMargin={index != 0}
                      />
                    )
                  })
                }
              </div>
            </div>
          </div>
        }

        <div className="ml-4">
          <div className="col-12 mt-4 bg-white p-0 shadow">
            <div className="bg-info p-3">
              <div className="d-flex justify-content-between">
                <div className="col-12 text-align-left title">Survey Average Percent Change</div>
                <ClinicianSelect therapists={therapists} handleChange={this.handleTherapistChange}/>
              </div>
              <div className="col-12 text-align-left description">These metrics are calculated by finding the percent change between the first and last survey submitted by each eligible client. In order for a client to be considered eligible in the survey related metrics below, the client must have taken the survey related to metric at least twice.</div>
            </div>
            <div className="col-12 d-flex flex-wrap p-4 ml-2">
              { 
                this.filteredMetrics(this.props.percentChangeMetrics,'percent_change_metrics_').map((metric, index) => {
                  return(
                    <SpotlightLayout
                      {...this.props}
                      visible
                      index={index}
                      key={index}
                      metric={metric}
                      therapist={selectedTherapist}
                      hasLeftMargin={index != 0}
                    />
                  )
                })
              }
            </div>
          </div>
        </div>

        <div className="pl-3 col-12 p-0 mt-5 bg-reg">
          <div className="shadow ml-2">
            <div className=" pt-4 p-3 d-flex flex-wrap bg-primary align-items-center justify-content-between">
              <div className="text-align-left title">Survey Average Score Per Month</div>
              <Select 
                className="col-12 col-lg-6 p-0 m-0 mt-sm-2 mt-lg-0 text-color-black"
                value={selectedOptionForAverage}
                onChange={this.handleChangeForAverage}
                options={this.generateOptionsForAverage()}/>
            </div>
            {
              this.filteredMetrics(this.props.averageScorePerMonthMetrics, 'average_score_per_month_metrics_').map((metric, index)=>{
                return <LineChartLayout showTitle={false} index={index} visible={selectedOptionForAverage.value == index} {...this.props} metric={metric} key={index}/>
              })
            }
          </div>
        </div>

        <div className="pl-3 col-12 p-0 mt-5 bg-reg">
          <div className="shadow ml-2">
            <div className=" pt-4 p-3 d-flex flex-wrap bg-primary align-items-center justify-content-between">
              <div className="text-align-left title">Survey Monthly Percent Change</div>
              <Select 
                className="col-12 col-lg-6 p-0 m-0 mt-sm-2 mt-lg-0 text-color-black"
                value={selectedOption}
                onChange={this.handleChange}
                options={this.generateOptions()}/>
            </div>
            {
              this.filteredMetrics(this.props.percentChangePerMonthMetrics, 'percent_score_per_month_metrics_').map((metric, index)=>{
                return <LineChartLayout showTitle={false} index={index} visible={selectedOption.value == index} {...this.props} metric={metric} key={index}/>
              })
            }
          </div>
        </div>

        { this.props.permissions.surveys.tres_vista_exit_survey &&
          <div className="ml-4">
            <div className="col-12 mt-4 bg-white p-0 shadow">
              <div className="bg-info p-3">
                <div className="col-12 text-align-left title">Exit Survey</div>
              </div>
              <div className="col-12 d-flex flex-wrap p-4 ml-2">
                {
                this.filteredMetrics(this.props.exitSurveyMetrics, 'exit_survey_metrics_', 'endpoint').map( (metric, index) => {
                  return <div className={classnames("pt-3", "col-12", "pl-0", { "pl-lg-3": true })} >
                    <div className='bg-reg shadow mt-2'>
                      <NumberHorizontalLayout {...this.props} metric={metric} index={index} /> 
                    </div>
                  </div>
                })
                }
              </div>
            </div>
          </div>
        }

        { this.props.permissions.surveys.tres_vista_client_discharge_survey &&
          <div className="ml-4">
            <div className="col-12 mt-4 bg-white p-0 shadow">
              <div className="bg-info p-3">
                <div className="col-12 text-align-left title">Exit Survey</div>
              </div>
              <div className="col-12 d-flex flex-wrap p-4 ml-2">
                {
                this.filteredMetrics(this.props.dischargeSurveyMetrics, 'discharge_survey_metrics_', 'endpoint').map( (metric, index) => {
                  return <div className={classnames("pt-3", "col-12", "pl-0", { "pl-lg-3": true })} >
                    <div className='bg-reg shadow mt-2'>
                      <NumberHorizontalLayout {...this.props} metric={metric} index={index} /> 
                    </div>
                  </div>
                })
                }
              </div>
            </div>
          </div>
        }

        { this.props.permissions.surveys.tres_vista_resident_transition_survey &&
          <div className="ml-4">
            <div className="col-12 mt-4 bg-white p-0 shadow">
              <div className="bg-info p-3">
                <div className="col-12 text-align-left title">Exit Survey</div>
              </div>
              <div className="col-12 d-flex flex-wrap p-4 ml-2">
                {
                this.filteredMetrics(this.props.transitionSurveyMetrics, 'transition_survey_metrics_', 'endpoint').map( (metric, index) => {
                  return <div className={classnames("pt-3", "col-12", "pl-0", { "pl-lg-3": true })} >
                    <div className='bg-reg shadow mt-2'>
                      <NumberHorizontalLayout {...this.props} metric={metric} index={index} /> 
                    </div>
                  </div>
                })
                }
                <div className={classnames("pt-3", "col-11", "pl-0", { "pl-lg-3": true })} key={this.props.transitionSurveyMetrics.length}>
                  <div className='bg-reg'>
                    <PieChartLayout {...this.props} metric={effective_parts_metric} index={this.props.transitionSurveyMetrics.length} /> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>



    )
  }
}

const  ClinicianSelect = (props) => {
  const [ current, setCurrent ] = useState({label:'All Clinicians', value: 0})
  const processedTherapists = props.therapists.map((t, index) => ({label: t.doctor_name, value: (!!t.doctor_name ? t.doctor_name.toLowerCase() : null )}))
  processedTherapists.unshift({label:'All Clinicians', value: 'all'})

  useEffect(() => {
    props.handleChange(current.value)
  }, [current])

  return(
    <div className="col-12 mb-3 d-flex justify-content-end">
      <Select 
        className="col-12 col-lg-6 p-0 m-0 mt-sm-2 mt-lg-0 text-color-black"
        value={current}
        onChange={(e)=>setCurrent(e)}
        options={processedTherapists}/>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    selectedOption: {value: 0, label: ''},
    organization_name: state.static.organization_name,
    permissions: state.static.permissions,
    hiddenOutcomes: state.settings.hiddenOutcomes,
    averageMetrics: metricDefinitions(state.static.organization_name, state.static.permissions)['surveys'].averageMetrics,
    percentChangeMetrics: metricDefinitions(state.static.organization_name, state.static.permissions)['surveys'].percentChangeMetrics,
    averageScorePerMonthMetrics: metricDefinitions(state.static.organization_name, state.static.permissions)['surveys'].averageScorePerMonthMetrics,
    percentChangePerMonthMetrics: metricDefinitions(state.static.organization_name, state.static.permissions)['surveys'].percentChangePerMonthMetrics,
    exitSurveyMetrics: metricDefinitions(state.static.organization_name, state.static.permissions)['surveys'].exitSurveyMetrics,
    dischargeSurveyMetrics: metricDefinitions(state.static.organization_name, state.static.permissions)['surveys'].dischargeSurveyMetrics,
    transitionSurveyMetrics: metricDefinitions(state.static.organization_name, state.static.permissions)['surveys'].transitionSurveyMetrics,
  }
}

export default connect(mapStateToProps)(SurveyMetrics)